var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-38 refer"},_vm._l((_vm.refer),function(item,index){return _c('span',{key:index,staticClass:"inSpan"},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }